/**
 * Global application configuration
 */
window.appConfig = {
    idenfyEnabled: process.env.MIX_IDENFY_ENABLED === 'true'
}; 